module.exports = __webpack_public_path__ + "media/images/web/home/index/header_bg_m-bd59f725d3b44e6a31b0e220c0c90170.webp";